import { useEffect, useRef, useCallback } from 'react';

const useScrollProgress = () => {
  const scrollContentRef = useRef(null);
  const progressBarRef = useRef(null);

  const throttle = (func, limit) => {
    let inThrottle;
    return function() {
      const args = arguments;
      const context = this;
      if (!inThrottle) {
        func.apply(context, args);
        inThrottle = true;
        setTimeout(() => inThrottle = false, limit);
      }
    }
  };

  const handleScroll = useCallback(() => {
    if (!scrollContentRef.current || !progressBarRef.current) return;

    const scrollTop = window.scrollY;
    const contentTop = scrollContentRef.current.offsetTop;
    const contentHeight = scrollContentRef.current.offsetHeight;
    const windowHeight = window.innerHeight;
    const maxScroll = contentHeight - windowHeight;

    let percent = 0;
    if (scrollTop > contentTop) {
      percent = Math.min(1, (scrollTop - contentTop) / maxScroll);
    }

    progressBarRef.current.style.width = `${percent * 100}%`;
  }, []);

  useEffect(() => {
    const throttledHandler = throttle(handleScroll, 16); // ~60fps
    window.addEventListener('scroll', throttledHandler);
    return () => window.removeEventListener('scroll', throttledHandler);
  }, [handleScroll]);

  return { scrollContentRef, progressBarRef };
};

export default useScrollProgress;